export function getTTVRMarkerName(name) {
    return "TTVR.".concat(name);
}
//# sourceMappingURL=getTTVRMarkerName.js.map